// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prefooter-wrapper[data-v-bf136cba]{align-items:center;display:flex;flex-direction:column;justify-content:space-between}@media (min-width:1024px){.prefooter-wrapper[data-v-bf136cba]{flex-direction:row}}.button-wrapper[data-v-bf136cba]{align-self:center;display:flex;flex-direction:column;justify-content:flex-end}@media (min-width:1024px){.button-wrapper[data-v-bf136cba]{flex-direction:row}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
